module.exports = __webpack_public_path__ + "img/VIB.9ace2d85.svg";